const TheHomeMain = () => import('../views/TheHomeMain.vue')
const TheHomeDashboard = () => import('../views/TheHomeDashboard.vue')
const TheHomeAddEducationSpace = () => import('../views/TheHomeAddEducationSpace')
const TheHomeAddResearchSpace = () => import('../views/TheHomeAddResearchSpace')
const TheHomeAddDatasetSpace = () => import('../views/TheHomeAddDatasetSpace')
const OrganizationUserManagement = () => import('../views/OrganizationUserManagement')
const OrganizationConfig = () => import('../views/OrganizationConfig')
const OrganizationConfigIntegrations = () => import('../views/OrganizationConfigIntegrations')
const OrganizationConfigSecrets = () => import('../views/OrganizationConfigSecrets')
const OrgTokens = () => import('@/modules/organization/views/OrgTokens.vue')
const SpaceConfiguration = () => import('@/modules/space/views/SpaceConfiguration.vue')
const SpaceConfigurationResourceMapping = () => import('@/modules/space/views/SpaceConfigurationResourceMapping.vue')
const SpaceConfigurationFeatures = () => import('@/modules/space/views/SpaceConfigurationFeatures.vue')
const SpaceConfigurationSecrets = () => import('@/modules/space/views/SpaceConfigurationSecrets.vue')
const SpaceConfigurationLfs = () => import('@/modules/space/views/SpaceConfigurationLfs.vue')
const SpaceConfigurationExternalStorage = () => import('@/modules/space/views/SpaceConfigurationExternalStorage.vue')
const SpaceConfigurationQuotas = () => import('@/modules/space/views/SpaceConfigurationQuotas.vue')
const SpaceUserManagement = () => import('@/modules/space/views/SpaceUserManagement')
const InstanceConfiguration = () => import('@/modules/instance/views/InstanceConfiguration.vue')
const PoolSettingsGeneral = () => import('@/modules/user/views/PoolSettingsGeneral.vue')
const PoolUserManagement = () => import('@/modules/user/views/PoolUserManagement.vue')
const AllSpacesTable = () => import('../components/AllSpacesTable.vue')
const Steppers = () => import('@/components/Steppers')
const ConfigRouteWrapper = {
    render: h => h('router-view')
}

export default [
    {
        path: '/org/:oid',
        name: 'home-main',
        components: {
            default: TheHomeMain
        },
        children: [
            {
                path: 'dashboard',
                name: 'home-dashboard',
                components: {
                    default: TheHomeDashboard
                }
            },
            {
                path: 'spaces',
                name: 'home-spaces',
                components: {
                    default: AllSpacesTable
                }
            },
            {
                path: 'education-spaces/add-class',
                name: 'home-add-class',
                components: {
                    default: TheHomeAddEducationSpace,
                    notifications: Steppers
                }
            },
            {
                path: 'research-spaces/add-research-project',
                name: 'home-add-research-project',
                components: {
                    default: TheHomeAddResearchSpace,
                    notifications: Steppers
                }
            },
            {
                path: 'dataset-spaces/add-dataset',
                name: 'home-add-dataset',
                components: {
                    default: TheHomeAddDatasetSpace,
                    notifications: Steppers
                }
            }
        ]
    },
    {
        path: '/config/org/:oid',
        name: 'config-main',
        components: {
            default: TheHomeMain
        },
        children: [
            {
                path: '',
                name: 'config-root',
                redirect: to => ({
                    name: 'config-org-general',
                    params: { oid: to.params.oid, sid: to.params.sid }
                }),
                components: {
                    default: ConfigRouteWrapper
                }
            },
            {
                path: 'general-settings',
                name: 'config-org-general',
                components: {
                    default: OrganizationConfig
                }
            },
            {
                path: 'secrets',
                name: 'config-org-secrets',
                components: {
                    default: OrganizationConfigSecrets
                }
            },
            {
                path: 'integrations',
                name: 'config-org-integrations',
                components: {
                    default: OrganizationConfigIntegrations
                }
            },
            {
                path: 'tokens',
                name: 'config-org-tokens',
                components: {
                    default: OrgTokens
                }
            },
            {
                path: 'users',
                name: 'config-org-users',
                components: {
                    default: OrganizationUserManagement
                }
            },
            {
                path: 'pool/:rpid?',
                name: 'config-pool',
                redirect: to => ({
                    name: 'config-pool-general',
                    params: { oid: to.params.oid, rpid: to.params.rpid }
                }),
                components: {
                    default: ConfigRouteWrapper
                },
                children: [
                    {
                        path: 'general-settings',
                        name: 'config-pool-general',
                        components: {
                            default: PoolSettingsGeneral
                        }
                    },
                    {
                        path: 'users',
                        name: 'config-pool-users',
                        components: {
                            default: PoolUserManagement
                        }
                    }
                ]
            },
            {
                path: 'space/:sid?',
                name: 'config-space',
                redirect: to => ({
                    name: 'config-space-general',
                    params: { oid: to.params.oid, sid: to.params.sid }
                }),
                components: {
                    default: ConfigRouteWrapper
                },
                children: [
                    {
                        path: 'general-settings',
                        name: 'config-space-general',
                        components: {
                            default: SpaceConfiguration
                        }
                    },
                    {
                        path: 'resource-mapping',
                        name: 'config-space-resource',
                        components: {
                            default: SpaceConfigurationResourceMapping
                        }
                    },
                    {
                        path: 'additional-features',
                        name: 'config-space-features',
                        components: {
                            default: SpaceConfigurationFeatures
                        }
                    },
                    {
                        path: 'secrets',
                        name: 'config-space-secrets',
                        components: {
                            default: SpaceConfigurationSecrets
                        }
                    },
                    {
                        path: 'users',
                        name: 'config-space-users',
                        components: {
                            default: SpaceUserManagement
                        }
                    },
                    {
                        path: 'large-file-storage',
                        name: 'config-space-lfs',
                        components: {
                            default: SpaceConfigurationLfs
                        }
                    },
                    {
                        path: 'cloud-storage',
                        name: 'config-space-cloud-storage',
                        components: {
                            default: SpaceConfigurationExternalStorage
                        }
                    },
                    {
                        path: 'quotas-and-usage',
                        name: 'config-space-quotas',
                        components: {
                            default: SpaceConfigurationQuotas
                        }
                    },
                    {
                        path: 'instance/:iid?',
                        name: 'config-instance',
                        redirect: to => ({
                            name: 'config-instance-general',
                            params: { oid: to.params.oid, sid: to.params.sid, iid: to.params.iid }
                        }),
                        components: {
                            default: ConfigRouteWrapper
                        },
                        children: [
                            {
                                path: 'general-settings',
                                name: 'config-instance-general',
                                components: {
                                    default: InstanceConfiguration
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
]
